module.exports = __webpack_public_path__ + "img/157.981ff902.jpg";